export default {"aBC": "(a)+(b)+(c)",
  "aboutUs": "Sobre nós",
  "accountDetail": "Perfil",
  "accountStatus": "Status do acesso",
  "action": "Ação",
  "active": "Ativo",
  "activeConsumesLicense": "Ativo (consome licença)",
  "activateDriver": "Ativar condutor",
  "activateDriverTooltip": "O condutor passará a consumir uma licença.",
  "activateCar": "Ativar viatura",
  "activateCarTooltip": "A viatura passará a consumir uma licença.",
  "activities": "Atividades",
  "activity": "Atividade",
  "activityTime": "Tempo de atividade",
  "activityTimes": "Tempo nas atividades",
  "adddriver": "Adddriver",
  "addCar": "Adicionar viatura",
  "addLicences": "Contratar mais licenças",
  "addNewAddresses": "Novo local de trabalho",
  "addNewAudits": "Add New Audits",
  "addNewBookletPage": "Add New Booklet Page",
  "addnewcardriver": "Atribuir condutor",
  "addNewCarDriver": "Atribuir condutor",
  "addNewCar": "Nova viatura",
  "addNewCars": "Nova viatura",
  "addNewClients": "Add New Clients",
  "addNewConfig": "Add New Config",
  "addNewContractItens": "Add New Contract Itens",
  "addNewContracts": "Add New Contracts",
  "addNewDrivercar": "Atribuir viatura",
  "addNewDriverCar": "Atribuir viatura",
  "addNewDrivers": "Novo condutor",
  "addNewFleets": "Registe nova frota",
  "addNewItens": "Add New Itens",
  "addNewLists": "Add New Lists",
  "addNewPermDriver": "Add New Perm Driver",
  "addNewPermiDriver2": "Add New Permi Driver2",
  "addNewPermiFleet2": "Add New Permi Fleet2",
  "addNewPermissions": "Add New Permissions",
  "addNewProducts": "Add New Products",
  "addNewReports": "Add New Reports",
  "addNewReportsLog": "Add New Reports Log",
  "addNewRequests": "Compra mais licenças",
  "addNewTabledisplaylabel": "Adicionar novo",
  "addNewUserdriver": "Add New Userdriver",
  "addNewUsers": "Add New Users",
  "address": "Local de Trabalho",
  "addresses": "Locais de Trabalho",
  "addressesAddress": "Endereço",
  "addressesCep": "Código Postal",
  "addressesCity": "Cidade",
  "addressesClient": "Cliente",
  "addressesContact": "Contato",
  "addressesContracts": "Contratos associados",
  "addressesDateCreated": "Data de Registo",
  "addressesDateUpdated": "Data de Atualização",
  "addressesDetail": "Detalhe do local de trabalho",
  "addressesDetails": "Detalhes do local de trabalho",
  "addressesDriver": "Condutor",
  "addressesDrivers": "Condutores no local",
  "addressesEmail": "Email",
  "addressesL1": "Morada",
  "addressesL2": "Complemento",
  "addressesLocality": "Localidade",
  "addressesNifNipc": "NIF / NIPC",
  "addressesObs": "Observações adicionais",
  "addressesPhone": "Telefone / Telemóvel",
  "addressesReference": "Referência",
  "addressesReviewedBy": "Revisto por",
  "addressesState": "Distrito",
  "addressesSystem": "Sistema associado",
  "admin": "Admin",
  "admission": "Data de início de atividade",
  "agreeTerms": "Agree Terms",
  "allRightsReserved": "Todos os direitos reservados",
  "alreadyExist": " Já existe!\r\n\t\t",
  "alreadyHaveAnAccount": "já tem uma conta?",
  "alterarAosDadosDeAcessoSomentePeloProprioUtilizador": "Alterar aos dados de acesso somente pelo proprio utilizador",
  "anual": "Anual",
  "application": "Application",
  "aquivado": "Aquivado",
  "arquivada": "Arquivada",
  "arquivadas": "Arquivadas",
  "arquivado": "Arquivado",
  "archiveDriver": "Arquivar condutor",
  "archiveDriverTooltip": "O condutor deixa de consumir licença e pode ser reativado a qualquer momento.",
  "archiveCar": "Arquivar viatura",
  "archiveCarTooltip": "A viatura deixa de consumir licença e pode ser reativada a qualquer momento.",
  "replaceCar": "Substituir viatura",
  "replaceCarTooltip": "Substituir esta viatura por uma nova, transferindo todas as atribuições aos condutores.",
  "replaceCarSubmit": "Confirmar substituição",
  "replacementInfo": "Informações de substituição",
  "oldCarRegister": "Matrícula anterior",
  "replacementDriverWarning": "Todos os condutores atribuídos a esta viatura serão transferidos para a nova viatura.",
  "replacementSummary": "Resumo da substituição",
  "replacementDetails": "Detalhes da substituição",
  "oldCar": "Viatura anterior",
  "newCar": "Nova viatura",
  "driverAssignmentsUpdated": "Atribuições de condutores atualizadas",
  "replacementProcessing": "Substituição em processamento...",
  "ativa": "Ativa",
  "ativas": "Ativas",
  "atividade": "Atividade",
  "ativo": "Ativo",
  "ativosLicenas": "Ativos/Licenças",
  "atribuidoAosCondutores": "Atribuido aos condutores",
  "atLeastOneCarRequired": "O condutor precisa de ao menos uma viatura atribuída para registrar atividades.",
  "audits": "Audits",
  "auditsDetails": "Audits Details",
  "available": "Disponível",
  "availablePlural": "Disponíveis",
  "assignedPlural": "Atribuídos",
  "Available": "Disponível",
  "Drive": "Conduzir",
  "Pause": "Repousar",
  "Rest": "Repousar",
  "Other work": "Outro trabalho",
  "Other job": "Outro emprego",
  "Otherwork": "Outro trabalho",
  "Otherjob": "Outro emprego",
  "availColor": "Avail Color",
  "back": "Costas",
  "birth": "Data de nascimento",
  "blocked": "Bloqueado",
  "bookletPage": "Booklet Page",
  "bookletPageDetails": "Booklet Page Details",
  "brand": "Marca",
  "browse": "procurar",
  "button": "Button",
  "calender": "Calender",
  "cancel": "Cancelar",
  "capitalLetter": "Letra maiúscula",
  "car": "Viatura",
  "cars": "Viaturas",
  "carsBookletPage": "Cars Booklet Page",
  "carsBrand": "Marca da viatura",
  "carsCar": "Cars Car",
  "carsClient": "Cars Client",
  "carsDateCreated": "Cars Date Created",
  "carsDateUpdated": "Cars Date Updated",
  "carsDetail": "Cars Detail",
  "carsDetails": "Detalhe da viatura",
  "carsDrivercar": "Atribuido aos condutores",
  "carsFleet": "Cars Fleet",
  "carsModel": "Modelo da viatura",
  "carsRegister": "Cars Register",
  "carsRegisterDate": "Cars Register Date",
  "carsStatus": "Cars Status",
  "category": "Categoria profissional",
  "cc": "Cc",
  "cep": "Código Postal",
  "changeEmail": "Mude o e-mail",
  "changepass": "changepass",
  "changepassword": "Mudar palavra-passe",
  "changePassword": "Mudar palavra-passe",
  "changeYouPassword": "Alterar a palavra-passe",
  "charactersMinimum": "Caracteres Mínimos",
  "checkingAvailability": "Checando disponibilidade ...",
  "chooseFilesOrDropFilesHere": "Escolha arquivos ou solte-os aqui",
  "city": "Concelho",
  "clickHereToLogin": "Clique aqui para logar",
  "client": "Client",
  "clientactivecontracts": "Contratos ativos",
  "clientContract": "Licenças",
  "clientContractDetails": "Client Contract Details",
  "clientcontracts": "Licenças",
  "clientName": "Client Name",
  "clientorders": "clientOrders",
  "clientRequests": "Solicitações de compra",
  "clients": "Clients",
  "clientsActivity": "Clients Activity",
  "clientsAddresses": "Clients Addresses",
  "clientsClient": "Clients Client",
  "clientsDateCreated": "Clients Date Created",
  "clientsDateUpdated": "Clients Date Updated",
  "clientsDetail": "Clients Detail",
  "clientsDetails": "Clients Details",
  "clientSince": "Cliente desde",
  "clientsLicense": "Clients License",
  "clientsLogo": "Clients Logo",
  "clientsName": "Clients Name",
  "clientsNipc": "Clients Nipc",
  "clientsObs": "Clients Obs",
  "clientsProduct": "Clients Product",
  "clientsReviewedBy": "Clients Reviewed By",
  "clientsStatus": "Clients Status",
  "close": "Fechar",
  "closed": "Fechado",
  "code": "Code",
  "color": "Color",
  "condutores": "Condutores",
  "condutoresAtivos": "Condutores ativos",
  "condutoresNaAplicaoDriverEGerentesNaFleet": "Condutores na aplicação  'driver' e Gerentes na 'fleet'.",
  "condutoresNaAplicaoDriverEGerentesNaFleetOAcessoPoderSerRealizadoNoNomeDoUtilizador": "Condutores na aplicação  'driver' e Gerentes na 'fleet'.  O Acesso poderá ser realizado no nome do Utilizador",
  "config": "Config",
  "configDetails": "Config Details",
  "configParameter": "Config Parameter",
  "confirmNewPassword": "Confirme a nova palavra-passe",
  "confirmPassword": "Confirme a palavra-passe",
  "confirmTheRequest": "Confirm the request.",
  "confirmTheRequestYouWillReceiveAnEmailWithPaymentDetailsLicenseActivationWillOccurAfterPaymentConfirmation": "Confirme a solicitação. \r\nVocê receberá um e-mail com detalhes de pagamento. A ativação da licença ocorrerá após a confirmação do pagamento.",
  "congratulations": "Parabéns!",
  "contact": "Contact",
  "contactEmail": "Email",
  "contactSystemAdmin": "Entre em contato com o administrador do sistema para obter mais informações",
  "contactUs": "Contate-Nos",
  "continue": "Continuar",
  "connectivity": {
    "online": "API Online",
    "offline": "sem acesso",
    "connecting": "Verificando ligação...",
    "noConnection": "Não foi possível aceder ao servidor",
    "needInternet": "Sem ligação à internet ou falha temporária de rede.",
    "reconnected": "Acesso ao servidor restabelecido",
    "yourIpIs": "O seu IP de acesso:",
    "restrictedAccess": "Acesso Restrito",
    "regionalRestrictionInfo": "Detectámos que o seu acesso provém de um endereço de rede (IP) com restrições de segurança.",
    "whatToDo": "O que fazer?",
    "contactSupportWithIp": "Por favor, desative qualquer VPN, Proxy ou Firewall que possa estar a simular uma localização fora de Portugal e tente novamente. Se o problema persistir, contacte o suporte fornecendo o IP abaixo."
  },
  "network": {
    "online": "API Online",
    "offline": "sem acesso",
    "noConnection": "Não foi possível aceder ao servidor",
    "needInternet": "Sem ligação à internet ou falha temporária de rede.",
    "reconnected": "Acesso ao servidor restabelecido",
    "yourIpIs": "O seu IP de acesso:",
    "tapToRetry": "Sem ligação. Toque aqui para testar a rede.",
    "retrying": "A ligar... estabilizando ligação"
  },
  "contract": "Contrato",
  "contractItens": "Contract Itens",
  "contractItensDetails": "Contract Itens Details",
  "contractRenewd": "Contract Renewd",
  "contracts": "Contratos",
  "contractsAddress": "Contracts Address",
  "contractsClient": "Contracts Client",
  "contractsContract": "Contracts Contract",
  "contractsContractItens": "Contracts Contract Itens",
  "contractsDateActivated": "Contracts Date Activated",
  "contractsDateCreated": "Contracts Date Created",
  "contractsDateDeactivated": "Contracts Date Deactivated",
  "contractsDateDue": "Contracts Date Due",
  "contractsDateIssued": "Contracts Date Issued",
  "contractsDatePayed": "Contracts Date Payed",
  "contractsDateUpdated": "Contracts Date Updated",
  "contractsDetail": "Contracts Detail",
  "contractsDetails": "Contracts Details",
  "contractsInvoice": "Contracts Invoice",
  "contractsObs": "Contracts Obs",
  "contractsPayment": "Contracts Payment",
  "contractsPermalink": "Contracts Permalink",
  "contractsProduct": "Contracts Product",
  "contractsRequest": "Contracts Request",
  "contractsReviewedBy": "Contracts Reviewed By",
  "contractsStatus": "Contracts Status",
  "contrata": "contrata",
  "contratoDeTrabalho": "Contrato de trabalho",
  "createRecord": "Criar registro",
  "cttItem": "Ctt Item",
  "cttitensduedate": "Cttitensduedate",
  "currentPassword": "Palavra-passe atual",
  "dadosDeContatatoNoAlteraAcessoDoCondutor": "Dados de contatato (não altera acesso do condutor) ",
  "dadosDeContato": "Dados de contato",
  "dadosParaCadastroDoCondutor": "Dados para cadastro do condutor",
  "dadosParaCadastroDoUtilizador": "Dados para cadastro do utilizador",
  "dark": "dark",
  "dataImportedSuccessfully": "Dados importados com sucesso",
  "date": "Date",
  "dateActivated": "Data de Início",
  "dateCreated": "Criado em",
  "dateDeactivated": "Date Deactivated",
  "dateDue": "Vencimento",
  "dateFrom": "Date From",
  "dateIssued": "Date Issued",
  "datePayed": "Date Payed",
  "dateTo": "Date To",
  "dateUpdated": "Data de atualização",
  "dateValidity": "Date Validity",
  "day": "Day",
  "defaultcar": "Defaultcar",
  "delete": "Excluir",
  "deleteAccount": "Deletar conta",
  "deleteRecord": "Apagar registro",
  "deleteSelected": "Excluir selecionado",
  "deleteThisRecord": "Excluir este registro",
  "description": "Description",
  "discount": "Discount",
  "dontHaveAnAccount": "Não tem uma conta?",
  "drive": "Drive",
  "driveA": "Conduzir (a)",
  "driveColor": "Drive Color",
  "driver": "Condutor",
  "driverActivities": "Atividades e relatórios",
  "driverCalendar": "Driver Calendar",
  "driverCalendarDetails": "Driver Calendar Details",
  "drivercar": "Drivercar",
  "drivercarDetails": "Drivercar Details",
  "drivers": "Condutores",
  "driversAdmission": "Drivers Admission",
  "driversBirth": "Drivers Birth",
  "driversCategory": "Drivers Category",
  "driversClient": "Drivers Client",
  "driversDateCreated": "Drivers Date Created",
  "driversDateUpdated": "Drivers Date Updated",
  "driversDetail": "Detalhe do condutor",
  "driversDetails": "Detalhes do condutor",
  "driversDriver": "Drivers Driver",
  "driversDriverCalendar": "Drivers Driver Calendar",
  "driversDrivercar": "Viaturas atribuídas",
  "driversEmail": "Drivers Email",
  "driversHomeAddress": "Drivers Home Address",
  "driversLicense": "Drivers License",
  "driversName": "Nome dos Condutores",
  "driversNif": "Drivers NIF",
  "driversObs": "Drivers Obs",
  "driversSelfemployed": "Drivers Selfemployed",
  "driversStatus": "Drivers Status",
  "statusFiledPending": "Arquivados e Migrados",
  "driverTransferredMessage": "Este utilizador está em outra empresa. Para retornar, deve ser arquivado na empresa atual e proceder como um novo cadastro.",
  "driversWrkAddress": "Drivers Wrk Address",
  "driversWrkFone": "Drivers Wrk Fone",
  "duration": "Duration",
  "eachNewLicenseAdds1OneVehicleAnd1OneDriver": "Cada nova licença adiciona 1 viatura e 1 condutor",
  "edit": "Alterar",
  "editAccount": "Alterar conta",
  "editAddresses": "Alterar local de trabalho",
  "editar": "Editar",
  "editBookletPage": "Edit Booklet Page",
  "editCars": "Alterar viatura",
  "editClients": "Alterar cliente",
  "editConfig": "Alterar configuração",
  "editContractItens": "Edit Contract Itens",
  "editContracts": "Alterar contrato",
  "editDrivercar": "Edit Drivercar",
  "editDrivers": "Alterar condutor",
  "editFleets": "Alterar frota",
  "editItens": "Edit Itens",
  "editLists": "Edit Lists",
  "editMyAccount": "Edite minha conta",
  "editPermDriver": "Edit Perm Driver",
  "editPermiDriver2": "Edit Permi Driver2",
  "editPermiFleet2": "Edit Permi Fleet2",
  "editPermissions": "Edit Permissions",
  "editProducts": "Edit Products",
  "editReports": "Edit Reports",
  "editReportsLog": "Edit Reports Log",
  "editTabledisplaylabel": "Editar ${TableDisplayLabel}",
  "editThisRecord": "Editar este registro",
  "editUserdriver": "Edit Userdriver",
  "editUsers": "Alterar  utilizador",
  "email": "Email",
  "emailAddressChanged": "Endereço de email alterado com sucesso",
  "emailAddressNotRegistered": "Endereço de email não está registrado",
  "emailAddressVerified": "O endereço de email já foi verificado",
  "emailNotChanged": "E-mail não alterado",
  "emailOrPhoneNumber": "E-mail ou número de telefone",
  "emailVerificationCompleted": "Confirmação de email concluída.",
  "emailVerificationResent": "A confirmação por e-mail foi reenviada",
  "emailVerificationSent": "Link de confirmação de e-mail enviado",
  "emailVerifiedAt": "Email Verified At",
  "endDate": "End Date",
  "endDay": "End Day",
  "endKm": "km final",
  "endTime": "End Time",
  "enterAccountStatus": "Entre o status do acesso",
  "enterActivity": "Enter Activity",
  "enterAdmission": "Enter Admission",
  "enterAgreeTerms": "Enter Agree Terms",
  "enterApplication": "Enter Application",
  "enterAvailColor": "Enter Avail Color",
  "enterBirth": "Enter Birth",
  "enterBrand": "Entre a marca",
  "enterCar": "Enter Car",
  "enterCategory": "Enter Category",
  "enterCc": "Enter Cc",
  "enterCep": "Insira o Código Postal",
  "enterCity": "Insira a Cidade",
  "enterClient": "Enter Client",
  "enterClosed": "Enter Closed",
  "enterCode": "Enter Code",
  "enterConfigParameter": "Enter Config Parameter",
  "enterContact": "Insira o Contato",
  "enterContactEmail": "Insira Email",
  "enterContractRenewd": "Enter Contract Renewd",
  "enterDateActivated": "Enter Date Activated",
  "enterDateDeactivated": "Enter Date Deactivated",
  "enterDateDue": "Enter Date Due",
  "enterDateFrom": "Enter Date From",
  "enterDateIssued": "Enter Date Issued",
  "enterDatePayed": "Enter Date Payed",
  "enterDateTo": "Enter Date To",
  "enterDateValidity": "Enter Date Validity",
  "enterDescription": "Enter Description",
  "enterDiscount": "Enter Discount",
  "enterDriveColor": "Enter Drive Color",
  "enterDriver": "Enter Driver",
  "enterDrivers": "Enter Drivers",
  "enterEmail": "Enter Email",
  "enterEmailVerifiedAt": "Enter Email Verified At",
  "enterEndKm": "Enter End Km",
  "enterFielddisplaylabel": "Entrar ${FieldDisplayLabel}",
  "enterFleet": "Enter Fleet",
  "enterFormat": "Enter Format",
  "enterFpasschange": "Enter Fpasschange",
  "enterFuelLiters": "Enter Fuel Liters",
  "enterHomeAddress": "Enter Home Address",
  "enterIncome": "Enter Income",
  "enterInvoice": "Enter Invoice",
  "enterIva": "Enter Iva",
  "enterL1": "Insira a Morada",
  "enterL2": "Complemento",
  "enterLabel": "Enter Label",
  "enterLicense": "Enter License",
  "enterLicenses": "Enter Licenses",
  "enterLocality": "Insira a Localidade",
  "enterLog": "Enter Log",
  "enterLogo": "Enter Logo",
  "enterManagerEmailOk": "Enter Manager Email Ok",
  "enterManagerNameOk": "Enter Manager Name Ok",
  "enterManagerTelOk": "Enter Manager Tel Ok",
  "enterMaxCars": "Enter Max Cars",
  "enterMaxDrivers": "Enter Max Drivers",
  "enterMaxFleets": "Enter Max Fleets",
  "enterModel": "Entre o modelo",
  "enterName": "Insira o nome",
  "enterNif": "Enter NIF",
  "enterNifNipc": "Enter Nif Nipc",
  "enterNipc": "Enter Nipc",
  "enterNipcNifOk": "Enter Nipc Nif Ok",
  "enterObs": "Enter Obs",
  "enterOjobColor": "Enter Ojob Color",
  "enterOtherExpense": "Enter Other Expense",
  "enterOtp": "Digite OTP",
  "enterOworkColor": "Enter Owork Color",
  "enterPassword": "Entre a Palavra-passe",
  "enterPauseColor": "Enter Pause Color",
  "enterPayment": "Valor",
  "enterPermalink": "Enter Permalink",
  "enterPermission": "Enter Permission",
  "enterPhone": "Insira o Telefone",
  "enterPrice": "Enter Price",
  "enterProduct": "Enter Product",
  "enterPvp": "Enter Pvp",
  "enterQuantity": "Enter Quantity",
  "enterReference": "Insira a Referência",
  "enterRegister": "Enter Register",
  "enterRegisterDate": "Enter Register Date",
  "enterReviewedBy": "Enter Reviewed By",
  "enterSelfemploed": "Enter Selfemploed",
  "enterSelfemployed": "Enter Selfemployed",
  "enterStartKm": "Enter Start Km",
  "enterState": "Insira o Distrito",
  "enterStatus": "Enter Status",
  "enterSystem": "Enter System",
  "enterText": "Enter Text",
  "enterTheCode": "Digite o código",
  "enterTimeallowance": "Enter Timeallowance",
  "enterTo": "Enter To",
  "enterType": "Enter Type",
  "enterUnit": "Enter Unit",
  "enterUser": "Enter User",
  "enterUserName": "Nome do utilizador",
  "enterUserRoleId": "Entre tipo de acesso",
  "enterValue": "Enter Value",
  "enterWrkAddress": "Enter Wrk Address",
  "enterWrkFone": "Enter Wrk Fone",
  "errorDeletingRecord": "Erro ao excluir o registro. por favor, certifique-se de que a saída de registro",
  "errorInsertingRecord": "Erro ao inserir registro",
  "errorProcessingRequest": "Erro ao processar a solicitação!",
  "errorRegisteringUser": "Erro ao registrar usuário",
  "errorSendingEmail": "Erro ao enviar email. Entre em contato com o administrador do sistema para mais informações",
  "errorUploadingFile": "Erro ao fazer o upload do arquivo",
  "excluir": "Excluir",
  "export": "Exportar",
  "exportCsv": "Exportar CSV",
  "exportExcel": "Exportar Excel",
  "exportPageFields": "Exportar campos de página",
  "exportWord": "Exportar Word",
  "failedJobs": "Failed Jobs",
  "false": "false",
  "filed": "Arquivado",
  "filedNotConsumesLicense": "Arquivado (não consome licença)",
  "fileFormatNotSupported": "Formato de arquivo não suportado",
  "filename": "Filename",
  "files2": "Files2",
  "filterByStatus": "Filtrar pelo Status",
  "fleet": "Frota",
  "fleetManager": "Gestor de frota",
  "fleets": "Frotas",
  "fleetsApplication": "Aplicação",
  "fleetsCars": "Carros Exclusivos",
  "fleetsClient": "Cliente Associado",
  "fleetsDetail": "Detalhe da frota",
  "fleetsDetails": "Detalhes da frota",
  "fleetsFleet": "Frota Alvo",
  "fleetsName": "Designação da Frota",
  "format": "Format",
  "formIsInvalid": "O formulário é inválido",
  "fpasschange": "Fpasschange",
  "fpasswordchange": "fpasswordchange",
  "fuelLiters": "Fuel Liters",
  "geolocations": "Geolocations",
  "helpAndFaq": "Ajuda e FAQ",
  "hi": "Oi",
  "home": "Casa",
  "homeAddress": "Morada",
  "id": "Id",
  "importData": "Importar dados",
  "incio": "Início",
  "income": "Income",
  "invalidCaptchaCode": "Código Captcha inválido",
  "invalidEmailVerifyLink": "O link de verificação de email não é válido\r\n\t\t",
  "invalidRequest": "Pedido inválido",
  "invoice": "Fatura",
  "item": "Item",
  "itens": "Itens",
  "itensDetails": "Itens Details",
  "iva": "Iva",
  "l1": "Morada linha 1",
  "l2": "Morada linha 2",
  "label": "Label",
  "language": "Língua",
  "lastCarAccessed": "Última viatura acessada",
  "latitude": "Latitude",
  "license": "Licença",
  "licenses": "Licenças",
  "limit": "Limite",
  "line": "Line",
  "listaddress": "Lista de Locais",
  "listdrivers": "Listdrivers",
  "listfleet": "Lista de Frotas",
  "lists": "Lists",
  "listsDetails": "Lists Details",
  "loading": "Carregando...",
  "loadMore": "Carregue mais...",
  "locality": "Freguesia",
  "log": "Alterações",
  "logId": "Log Id",
  "login": "Entrar",
  "loginCompleted": "Login completado",
  "logo": "Logo",
  "logoff": "logoff",
  "logout": "Sair",
  "longitude": "Longitude",
  "manager": "Gerente",
  "managerEmailOk": "Manager Email Ok",
  "managerNameOk": "Manager Name Ok",
  "managerTelOk": "Manager Tel Ok",
  "maxCars": "Max Cars",
  "maxDrivers": "Max Drivers",
  "maxFleets": "Max Fleets",
  "migrations": "Migrations",
  "model": "Modelo",
  "myAccount": "Meu perfil",
  "mycompany": "Minha empresa",
  "myplan": "Meu plano",
  "timezone": "Fuso horário (emissão de relatórios)",
  "name": "Nome",
  "nenhumRegistroEncontrado": "Nenhum Registro Encontrado",
  "newPassword": "Nova palavra-passe",
  "newValues": "New Values",
  "nif": "NIF",
  "nifNipc": "NIF NIPC",
  "nipc": "Nipc",
  "nipcNifOk": "Nipc Nif Ok",
  "no": "Não",
  "noFileSelectedForUpload": "Nenhum arquivo selecionado para upload",
  "noMoreContentToLoad": "Não há mais conteúdo para carregar",
  "noRecordFound": "Nenhum Registro Encontrado",
  "noRecordInserted": "Nenhum registro inserido",
  "noRecordUpdated": "Nenhum registro atualizado",
  "noRequestFound": "Não há solicitações de compra",
  "notAvailable": "Não disponível",
  "number": "Número",
  "oAcessoAoSistemaPodeSerRealizadoPeloNomeDoUtilizador": "O acesso ao sistema pode ser realizado pelo nome do utilizador. ",
  "oauthAccessTokens": "Oauth Access Tokens",
  "oauthAuthCodes": "Oauth Auth Codes",
  "oauthClients": "Oauth Clients",
  "oauthPersonalAccessClients": "Oauth Personal Access Clients",
  "oauthRefreshTokens": "Oauth Refresh Tokens",
  "obs": "Obs",
  "of": "do",
  "ojobColor": "Ojob Color",
  "oldValues": "Old Values",
  "ordaerDate": "Ordaer date",
  "order": "Solicitar",
  "orderDate": "Data",
  "orderUpdated": "Data da ultima alteração",
  "otherExpense": "Other Expense",
  "otherJob": "Other Job",
  "otherJobC": "Outro emprego (c)",
  "otherWork": "Other Work",
  "otherWorkB": "Outro trabalho (b)",
  "otpSentEmail": "OTP foi enviado para o seu e-mail",
  "otpSentSMS": "OTP foi enviado para o seu número de telefone via SMS",
  "otpVerification": "Verificação OTP",
  "oUtilizadorDeveAlterarNoDriverOuNoFleetOsDadosDeAcesso": "O utilizador deve alterar no 'driver' ou no 'fleet' os dados de acesso.",
  "oworkColor": "Owork Color",
  "page": "Página",
  "password": "Palavra-passe",
  "passwordChangedMsg": "Sua palavra-passefoi alterada",
  "passwordHint": "Dicas: Não menos de 6 caracteres",
  "passwordReset": "Gerenciador de redefinição de palavra-passe",
  "passwordResetKeyFailure": "Falha na chave de redefinição de palavra-passe",
  "passwordResetLinkMsg": "Um link será enviado para o seu e-mail contendo as informações necessárias para sua palavra-passe",
  "passwordResetMsg": "Uma mensagem foi enviada para o seu email. Por favor, siga o link para redefinir sua palavra-passe",
  "passwordResets": "Password Resets",
  "passwordResetStepsMsg": "Por favor, você pode tentar redefinir sua palavra-passe seguindo estes passos",
  "pauseColor": "Pause Color",
  "payment": "Periodicidade",
  "pendente": "Migrado",
  "pendenteAguardaRevisoActivoEmCobrana": "Pendente: Aguarda revisão / Activo: em cobrança",
  "pendenteAguardaRevisoAtivoEmCobrana": "Pendente: Aguarda revisão / Ativo: em cobrança",
  "pendentes": "Pendentes",
  "pending": "Migrado",
  "permalink": "Permalink",
  "permDriver": "Perm Driver",
  "permDriverDetails": "Perm Driver Details",
  "permiadmin2": "Permiadmin2",
  "permiDriver2": "Permi Driver2",
  "permiDriver2Details": "Permi Driver2 Details",
  "permiFleet": "Permi Fleet",
  "permiFleet2": "Permi Fleet2",
  "permiFleet2Details": "Permi Fleet2 Details",
  "permission": "Permission",
  "permissionId": "Permission Id",
  "permissions": "Permissions",
  "permissionsDetails": "Permissions Details",
  "permiVendas2": "Permi Vendas2",
  "permiVendas3": "Permi Vendas3",
  "phone": "Telefone",
  "phoneNumber": "Número de telefone",
  "photo": "Photo",
  "places": "Locais",
  "pleaseAChooseFile": "Por favor, escolha um arquivo",
  "pleaseCompleteTheForm": "Por favor, preencha o formulário",
  "pleaseEnterText": "Por favor insira o texto",
  "pleseConfirmTheRequest": "Plese confirm the request.",
  "price": "Price",
  "print": "Impressão",
  "printPageSettings": "Imprimir configurações da página",
  "printPdf": "Impressão | PDF",
  "privacyPolicy": "Política de Privacidade",
  "product": "Produto",
  "productName": "Produto",
  "products": "Products",
  "productsClients": "Products Clients",
  "productsDetail": "Products Detail",
  "productsDetails": "Products Details",
  "promptAccountBlocked": "Sua conta foi bloqueada",
  "promptAccountCreated": "Sua conta foi criada",
  "promptAccountInReview": "Sua conta está aguardando revisão",
  "promptAccountNotActive": "Sua conta não está ativa. Entre em contato com o administrador do sistema para obter mais informações",
  "promptDeleteRecord": "Tem certeza de que deseja excluir este registro?",
  "promptDeleteRecords": "Tem certeza de que deseja excluir esses registros?\r\n\t\t",
  "promptEmailNotRegistered": "O endereço de email ou NIF não está registrado no sistema\r\n\t\t",
  "promptForValidEmail": "Por favor, forneça o email ou NIF válido que você usou para se registrar",
  "promptPasswordConfirmFail": "Sua confirmação de palavra-passe não é consistente",
  "promptPasswordExpired": "Sua palavra-passe expirou. Redefina sua senha para continuar.",
  "promptPasswordResetFailed": "Sua redefinição de palavra-passe não foi concluída",
  "provideNewPassword": "Nova palavra-passe ",
  "pvp": "Pvp",
  "quantity": "Quantity",
  "recordAddedSuccessfully": "Registro adicionado com sucesso",
  "recordDeletedSuccessfully": "Registro excluído com sucesso",
  "recordId": "Record Id",
  "records": "Registros",
  "recordUpdatedSuccessfully": "Registro atualizado com sucesso",
  "reference": "Referência",
  "registaParaUtilizar": "Regista para utilizar",
  "register": "Matrícula",
  "registerDate": "Primeiro registo",
  "registroExcludoComSucesso": "Registro excluído com sucesso",
  "rememberMe": "Lembre de mim",
  "removePageLinks": "Remover links da página",
  "removerAtribuio": "Remover atribuição",
  "report": "Report",
  "reports": "Reports",
  "reportsDetails": "Reports Details",
  "reportsLog": "Reports Log",
  "reportsLogDetails": "Reports Log Details",
  "request": "Requisição",
  "requestInProcess": "Request in process",
  "requestInProcessing": "Solicitações em processamento",
  "requests": "Requests",
  "requestsContracts": "Requests Contracts",
  "requestsDetail": "Requests Detail",
  "requestUrl": "Request Url",
  "resendEmail": "Reenviar email",
  "resetcookies": "Redefinir Cookies",
  "resetPassword": "Redefinir palavra-passe",
  "forgotPassword": "Esqueceu-se da sua palavra-passe?",
  "rest": "Repousar",
  "reverse": "Reverse",
  "reviewedBy": "Reviewed By",
  "roleId": "Role Id",
  "roleName": "Role Name",
  "roles": "Roles",
  "rolesadmin": "Rolesadmin",
  "rolesDetail": "Roles Detail",
  "rolesPermissions": "Roles Permissions",
  "rolesUsers": "Roles Users",
  "savePng": "Salvar PNG",
  "saving": "Registro de economia",
  "search": "Pesquisa",
  "settings": "Configurações",
  "selectAFileToImport": "Selecione um arquivo para importar",
  "selectAValue": "Selecione um valor ...",
  "selectPaperSize": "Selecione o tamanho do papel",
  "selfemploed": "Selfemploed",
  "selfemployed": "Trabalhador por conta própria",
  "send": "Enviar",
  "shouldContain": "Deve conter",
  "showHeader": "Mostrar Cabeçalho",
  "sim": "Sim",
  "somenteContatato": "somente contatato: ",
  "somenteDadosDeContatatoNoAlteraAcessoDoCondutor": "Somente dados de contatato (não altera acesso do condutor: ",
  "sortBy": "Ordenar por",
  "startDate": "Start Date",
  "startDay": "Start Day",
  "startEnd": "Registo diario",
  "startEndDetails": "Start End Details",
  "startKm": "km inicial",
  "startTime": "Start Time",
  "state": "Distrito",
  "status": "Status",
  "statusDuration": "Status Duration",
  "submit": "Enviar",
  "success": "Sucesso",
  "supportedFileTypes": "",
  "symbol": "Símbolo",
  "system": "System",
  "tabledisplaylabelDetails": "Visão",
  "temCertezaDeQueDesejaExcluirEsteRegistro": "Tem certeza de que deseja excluir este registro?",
  "termsAndConditions": "Termos e Condições",
  "teste": "teste",
  "text": "Text",
  "theDashboard": "O painel",
  "thisPageIsForNewDriversOnlyToTransferAnExistingDriverPleaseContactSupport": "Esta página é apenas para novos condutores no Livrete. Para transferir um condutor registrado, entre em contato com o suporte.",
  "timeallowance": "Timeallowance",
  "timestamp": "Timestamp",
  "to": "To",
  "total": "Total",
  "totalHoursDay": "Total Hours Day",
  "totalValue": "Valor",
  "totalWorkingHours": "Total working hours",
  "trabalhadorPorContaPropria": "Trabalhador por conta propria",
  "trmino": "Término",
  "true": "true",
  "tstatus": "Status",
  "type": "Type",
  "unableToConnect": "Não foi possível estabelecer conexão...",
  "unableToCompleteRequest": "Não é possível concluir o pedido.",
  "developedBy": "Solução desenvolvida por Fusão Eterea - Unip. Lda., &copy; 2025",
  "unit": "Unit",
  "unitiCost": "Uniti Cost",
  "update": "Atualizar",
  "updateRecord": "Atualizar registro",
  "user": "User",
  "userAgent": "User Agent",
  "userdriver": "Userdriver",
  "userdriverDetails": "Userdriver Details",
  "userId": "User Id",
  "userIp": "User Ip",
  "userLogin": "Login de usuário",
  "username": "Nome do utilizador",
  "userName": "Nome de usuário",
  "usernameEmailPhoneNumber": "Nome do utilizador / e-mail / número de telefone",
  "usernameOrEmail": "Email ou NIF",
  "usernameOrPasswordNotCorrect": "Nome do utilizador ou palavra-passe não está correto",
  "usernameOrPhoneNumber": "Nome do utilizador ou número de telefone",
  "userRegistration": "Registro do usuário",
  "userRoleId": "Acesso",
  "users": "Utilizadores",
  "usersDetails": "Users Details",
  "value": "Value",
  "vdsRequests": "Vds Requests",
  "verify": "Verificar",
  "verifyEmailLinkMsg": "Por favor, verifique seu endereço de e-mail seguindo o link em sua caixa postal",
  "view": "Visão",
  "viewMore": "Detalhe",
  "viewRecord": "Ver registro",
  "viso": "Visão",
  "vnculo": "Vínculo",
  "week": "Week",
  "weekstartdate": "Weekstartdate",
  "welcome": "Bem-vindo",
  "wrkAddress": "Local de trabalho",
  "wrkFone": "Telefone",
  "wsday": "Wsday",
  "youNeedToLogInAgain": "É necessário fazer o login novamente",
  managerPage: {
    welcomeTitle: "Bem-vindo ao Livrete Fleet!",
    welcomeDescription: "Esta é a sua plataforma de gestão enquanto operador de transporte.<br><br>Aqui, poderá criar e gerir condutores e viaturas, atribuir quais condutores podem conduzir determinados veículos, monitorizar as atividades de todos os condutores e gerar relatórios para gestão e fiscalização.<br><br><strong>Registe a sua primeira viatura.</strong>",
    doNotShowAgain: "Não mostrar novamente",
    paymentReferenceTitle: "Referência de pagamento",
    paymentDataTitle: "Dados para pagamento",
    paymentInstruction: "Use estes dados para concluir a cobrança.",
    method: "Método",
    entity: "Entidade",
    reference: "Referência",
    amount: "Valor",
    validUntil: "Válido até",
    guidelinesDrivers: "Orientações - Condutores",
    driversWithoutCarAlert: "Existem ${count} condutores sem viatura associada. Verifique e faça a associação para evitar bloqueios operacionais.",
    guidelinesCars: "Orientações - Viaturas",
    carsWithoutDriverAlert: "Existem ${count} viaturas ativas sem condutor associado. Verifique e faça a associação para evitar bloqueios operacionais.",
    guidelinesContracts: "Orientações - Contratos",
    contractsDueAlert: "Existem ${count} contratos com validade vencida ou a vencer nos próximos 30 dias.",
    contractLabel: "Contrato",
    validity: "vigência",
    waitBillingRenewal: "Aguarde a cobrança para pagamento da renovação.",
    expiresTodayWaitBilling: "Vence hoje. Aguarde a cobrança para pagamento da renovação.",
    expiresInDaysWaitBilling1: "Vence em ${days} dia.",
    expiresInDaysWaitBilling: "Vence em ${days} dias.",
    guidelinesBillings: "Orientações - Cobranças",
    activeBillingsAlert: "Existem ${count} cobranças ativas para contratos. Clique em método/validade para ver os dados de pagamento.",
    suspendedPaymentAlert: "Referência suspensa, mas pode ser paga a qualquer momento para reativar o seu plano.",
    warnFiledDrivers: "Atenção: Licenças (${lic}) - Ativos (${act}) - Drivers do contrato (${ctr}) = ${bal}. Ao vencer este contrato, todos os condutores ativos serão arquivados (Filed).",
    warnFiledCars: "Atenção: Licenças (${lic}) - Viaturas ativas (${act}) - Viaturas do contrato (${ctr}) = ${bal}. Ao vencer este contrato, todas as viaturas ativas serão arquivadas (Filed).",
    cars: "Viaturas",
    activeLicensesCars: "Ativas/Licenças",
    startManagingFleet: "Prepare-se para gerenciar sua frota como nunca!",
    manageFleetDescription: "Aqui, você controlará viaturas, condutores, monitorará atividades de condução e trabalho da equipe, e gerará relatórios essenciais.<br><strong>Vamos começar?</strong> Siga estes passos simples:<br>1. <strong>Cadastre sua primeira viatura:</strong> Insira todos os dados obrigatórios.<br>2. <strong>Cadastre seu primeiro condutor:</strong> Preencha as informações solicitadas e associe as viaturas que ele pode utilizar.",
    wantIncreaseCars: "Quer aumentar a quantidade de viaturas?",
    changePlan: "Altera o plano",
    fleets: "Frotas",
    groupCarsToFacilitate: "Agrupe viaturas para facilitar a gestão",
    drivers: "Condutores",
    activeLicensesDrivers: "Ativos/Licenças",
    noDriversRegistered: "Não há condutores cadastados",
    registerFirstDriverText: "<strong>Cadastre seu primeiro condutor:</strong> Preencha as informações solicitadas e associe as viaturas que ele pode utilizar.",
    wantIncreaseDrivers: "Quer aumentar a quantidade de condutores?",
    workLocations: "Locais de trabalho",
    manageWorkLocations: "Gerencie os locais de trabalho dos seus condutores",
    contractInRenewal: "Contrato em renovação",
    request: "Requisição",
    paymentMethod: "Forma de pagamento",
    type: "Tipo: ${method}",
    ok: "Ok"
  },
  myPlanPage: {
    cancelRequestTitle: "Confirmação",
    cancelRequestMsg: "Deseja cancelar esta solicitação pendente?",
    requestCanceled: "Solicitação cancelada com sucesso.",
    buyMoreLicenses: "Compra mais licenças.",
    request: "Solicitação",
    pendingRequestAlert: "Há Solicitação Pendente.",
    cancel: "Cancelar",
    settings: "Configurações",
    timezone: "Fuso Horário (Timezone)",
    contractRenewal: "Renovação de Contrato",
    cancelRenewalLabel: "Não quero mais renovar todos os meus contratos",
    cancelRenewalHelp: "Ao ativar esta opção, todos os seus contratos ativos deixarão de ser renovados automaticamente e os serviços serão descontinuados após as respetivas datas de vencimento.",
    confirmCancelRenewalTitle: "Não Renovar Todos os Contratos",
    confirmCancelRenewalMsg: "Tem a certeza de que não deseja renovar todos os seus contratos automaticamente?<br><br>Se confirmar, o serviço será descontinuado no final da vigência de cada contrato ativo.",
    confirmCancelRenewalOk: "Sim, não renovar contratos",
    confirmCancelRenewalCancel: "Não, manter contratos ativos",
    renewalOptionUpdated: "Opção de renovação de contrato atualizada."
  },
  carsPage: {
    onboardingTitle: "Prepare-se para gerenciar sua frota como nunca!",
    onboardingDesc: "Aqui, você controlará viaturas, condutores, monitorará atividades de condução e trabalho da equipe, e gerará relatórios essenciais.",
    letsStart: "Vamos começar?",
    followSteps: "Siga estes passos simples:",
    step1Title: "Cadastre Sua Primeira Viatura:",
    step1Desc: "Insira todos os dados obrigatórios.",
    step2Title: "Cadastre Seu Primeiro Condutor:",
    step2Desc: "Preencha as informações solicitadas e associe as viaturas que ele pode utilizar.",
    assignCar: "Atribuir Viatura",
    assignCarsCount: "Atribuir Viaturas (${count})",
    selectDriverFirst: "Selecione um condutor antes de atribuir viaturas.",
    carAssignedSuccess: "Viatura(s) atribuída(s) com sucesso!"
  },
  driversPage: {
    yes: "Sim",
    no: "Não",
    noDriverRegisteredTitle: "Sem Condutor Cadastrado",
    noDriverRegisteredDesc: "Vamos organizar sua frota? Antes de adicionar um condutor, é importante garantir que a viatura utilizada por ele já esteja devidamente cadastrada no sistema.",
    assignDriver: "Atribuir Condutor",
    assignDriversCount: "Atribuir Condutores (${count})",
    selectCarFirst: "Selecione uma viatura antes de atribuir condutores.",
    driverAssignedSuccess: "Condutor(es) atribuído(s) com sucesso!",
    availableDrivers: "Condutores Disponíveis"
  },
  connectivity: {
    restrictedAccess: "Detectámos que o seu acesso provém de um endereço de rede (IP) com restrições de segurança.",
    whatToDo: "O que fazer?",
    contactSupportWithIp: "Por favor, contacte o suporte técnico e forneça o seu IP público para solicitar acesso.",
    yourIpIs: "O seu IP é:"
  },
  network: {
    online: "API Online",
    offline: "sem acesso",
    noConnection: "Não foi possível aceder ao servidor",
    needInternet: "Sem ligação à internet ou falha temporária de rede.",
    reconnected: "Acesso ao servidor restabelecido",
    yourIpIs: "O seu IP de acesso:",
    tapToRetry: "Sem ligação. Toque aqui para tentar novamente.",
    retrying: "A ligar... estabilizando ligação"
  },
  copy: "Copiar",
  goToHomePage: "Voltar à Página Inicial",

  suspensaoDeContrato: "Suspensão de Renovação",
  processandoPedido: "A processar o seu pedido...",
  tokenNaoFornecido: "Token de validação não fornecido.",
  tokenErroDesc: "Por favor, utilize o link recebido no e-mail de cobrança.",
  suspensaoEfetuada: "Renovação Suspensa com Sucesso!",
  suspensaoSucessoDesc: "A renovação automática deste contrato foi cancelada. Não receberá mais e-mails de cobrança relativos a este período.",
  erroAoSuspender: "Não foi possível suspender a renovação.",
  tentarNovamente: "Tentar Novamente",
  confirmarCancelamentoDesc: "Ao confirmar, o contrato não será renovado automaticamente no final do período ativo corrente.",
  confirmarNaoRenovacao: "Não quero renovar o contrato",

	validations: {
		required: "O valor é obrigatório.",
		undefined: "O valor é obrigatório.",
		email: "O valor não é um endereço de e-mail válido",
		minLength: "Este campo deve ter pelo menos ${min} caracteres",
		maxLength: "O comprimento máximo permitido é ${max}",
		minValue: "O valor mínimo permitido é ${min}",
		maxValue: "O valor máximo permitido é ${max}",
		numeric: "O valor deve ser numérico",
		ipAddress: "O valor não é um endereço IP válido",
		sameAs: "O valor deve ser igual ao valor ${otherName}",
	}
}
